import React, { useState, useEffect } from "react";
import { Card, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import config from '../config';
import { useAuth } from '../context/AuthContext';
import { Avatar } from 'primereact/avatar';
import { AvatarGroup } from 'primereact/avatargroup';
import { Tooltip } from 'primereact/tooltip';
import { Badge } from 'react-bootstrap';
import noUserImg from '../assets/images/no_user.png';

const PostHistory = ({ brandId }) => {
    const { accessToken } = useAuth();
    const currentYear = new Date().getFullYear();
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [calendarStats, setCalendarStats] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!brandId) return; // Ensure brandId is provided before making the API call

        const fetchCalendarStats = async () => {
            setLoading(true);
            try {
                const response = await axios.get(
                    `${config.apiBASEURL}/BrandBookRoutes/brand-calendar/stats`,
                    {
                        params: { brand_id: brandId, year: selectedYear },
                        headers: { Authorization: `Bearer ${accessToken}` },
                    }
                );
                setCalendarStats(response.data.events || {});
            } catch (error) {
                console.error("Error fetching calendar stats:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCalendarStats();
    }, [brandId, selectedYear, accessToken]);



    return (
        <Card className="view-card">
            <Card.Header className="h6 border-0 bg-light d-flex justify-content-between align-items-center">Post History

                <div className="d-flex align-items-center">

                    <Form.Select
                        value={selectedYear}
                        onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                        style={{ width: "100px" }}
                    >
                        {[...Array(5)].map((_, i) => {
                            const year = currentYear - i;
                            return (
                                <option key={year} value={year}>
                                    {year}
                                </option>
                            );
                        })}
                    </Form.Select>
                </div>

            </Card.Header>
            <Card.Body className="p-0 pb-2">
                <div className="timeline">
                    {Object.entries(calendarStats).map(([month, eventTypes]) => (
                        <div key={month}>
                            <div className="timeline-month" style={{fontSize: '16px'}}>
                                {new Date(2025, month - 1).toLocaleString("en-US", {
                                    month: "short",
                                    year: "numeric",
                                })}
                                <span style={{fontSize: '16px', left: 'calc(100% - 16px)', backgroundColor: '#ff9800', border: '1px solid #ff9800'}}>
                                    <small>Total : </small> <b>{Object.values(eventTypes).reduce((acc, event) => acc + Object.values(event).reduce((a, b) => a + b, 0), 0)}</b>
                                </span>
                            </div>

                            {Object.entries(eventTypes).map(([eventName, statuses]) => (
                                <div className="timeline-section" key={eventName}>
                                    <div className="timeline-date">
                                        {eventName} <b>({Object.values(statuses).reduce((a, b) => a + b, 0)})</b>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="timeline-box">
                                                <div className="box-content">
                                                    <div className="box-item2">
                                                        <ul className="Postcount">
                                                            {Object.entries(statuses).map(([status, count]) => (
                                                                <li key={status}>
                                                                    <small>{status}</small>
                                                                    <span className={getStatusColor(status)}>{count}</span>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </Card.Body>
        </Card>
    );
};

// Function to get status colors dynamically
const getStatusColor = (status) => {
    const statusColors = {
        Pending: "text-warning",
        Posted: "text-success",
        Cancelled: "text-secondary",
        Date_Changed: "text-info",
        Deadline_missed: "text-danger",
    };
    return statusColors[status] || "text-dark";
};

export default PostHistory;
